<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option value="">{{ firstOption }}</option>
    <option
      v-for="plan in selects"
      :key="plan.id"
      :value="plan.id"
      :selected="plan.id == selected"
      >{{ plan.name }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectPlans',
  data() {
    return {
      firstOption: this.first ? this.first : 'Todos',
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
    productId: {
      type: [Number, String],
    },
  },
  methods: {
    getData(productId) {
      if (!productId) {
        this.selects = [];
        return;
      }
      axios(
        `${baseApiUrl}/v1/plans/list?productId=${productId}&isRecurrent=1&isUnique=0&getCountable=1`
      ).then((res) => {
        this.selects = res.data;
      });
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    if (this.productId) {
      this.getData(this.productId);
    }
  },
  watch: {
    productId(newVal) {
      this.getData(newVal);
    },
  },
};
</script>
